import { render, staticRenderFns } from "./jhi-item-count.vue?vue&type=template&id=540ab44b"
import script from "./jhi-item-count.component.ts?vue&type=script&lang=ts&external"
export * from "./jhi-item-count.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports